import { TESTIMONIALS } from "@/lib/content";
import Reveal from "@/components/landing/Reveal";

export default function Testimonials() {
    return (
        <section
            data-testid="testimonials-section"
            className="bg-pearl-soft py-32 md:py-44"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12">
                <div className="text-center max-w-[40rem] mx-auto">
                    <Reveal>
                        <p className="eyebrow text-cacao/60 mb-6">
                            <span className="divider-line text-cacao/40 mr-4 align-middle" />
                            In their words
                            <span className="divider-line text-cacao/40 ml-4 align-middle" />
                        </p>
                    </Reveal>
                    <Reveal delay={120}>
                        <h2
                            data-testid="testimonials-headline"
                            className="font-serif text-cacao text-[2rem] sm:text-[2.6rem] md:text-[3.2rem] leading-[1.1]"
                        >
                            Homes that finally feel like{" "}
                            <em className="italic text-clay-deep">theirs.</em>
                        </h2>
                    </Reveal>
                </div>

                <div
                    className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10"
                    data-testid="testimonials-grid"
                >
                    {TESTIMONIALS.map((t, i) => (
                        <Reveal
                            key={t.name + t.suburb}
                            delay={i * 140}
                            className="relative px-2 md:px-4"
                        >
                            <span
                                aria-hidden="true"
                                className="absolute -top-10 left-0 font-serif text-clay/40 text-[6rem] leading-none select-none"
                            >
                                &ldquo;
                            </span>
                            <blockquote className="relative">
                                <p className="font-serif italic text-cacao text-[1.3rem] md:text-[1.45rem] leading-[1.55]">
                                    {t.quote}
                                </p>
                                <footer className="mt-8 text-cacao/65 text-[0.78rem] tracking-[0.22em] uppercase">
                                    — {t.name}{t.suburb ? `, ${t.suburb}` : ""}
                                </footer>
                            </blockquote>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
